import {
  GET_NUTRITION_LOGS_SUCCEED,
  GET_NUTRITION_LOGS_ERROR,
  GET_ALL_NUTRITION_LOGS_SUCCEED,
  GET_ALL_NUTRITION_LOGS_ERROR,
  GET_NUTRITION_SUMMARY_SUCCEED,
  GET_NUTRITION_SUMMARY_ERROR,
  LOADING_STATE,
  LOADING_NUTRITION_LOG_STATE,
  LOADING_ALL_NUTRITION_LOG_STATE
} from './types';

const INITIAL_STATE = {
  nutritionLogs: [],
  next: '',
  previous: '',
  previousState: [],
  logs: [],
  nutritionSummary: {},
  loading: false,
  loadingNutritionLog: false,
  loadingAllNutritionLog: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_NUTRITION_LOGS_SUCCEED) {
    return {
      ...state,
      nutritionLogs: action.payload,
      next: action.next,
      previous: action.previous,
      loadingNutritionLog: false
    };
  } else if (action.type === GET_NUTRITION_LOGS_ERROR) {
    return { ...state, error: action.payload, loadingNutritionLog: false };
  } else if (action.type === GET_ALL_NUTRITION_LOGS_SUCCEED) {
    return {
      ...state,
      logs: action.payload,
      loadingAllNutritionLog: false
    };
  } else if (action.type === GET_ALL_NUTRITION_LOGS_ERROR) {
    return { ...state, error: action.payload, loadingAllNutritionLog: false };
  } else if (action.type === GET_NUTRITION_SUMMARY_SUCCEED) {
    return {
      ...state,
      nutritionSummary: action.payload,
      loading: false
    };
  } else if (action.type === GET_NUTRITION_SUMMARY_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === LOADING_STATE) {
    return { ...state, loading: true};
  } else if (LOADING_NUTRITION_LOG_STATE) {
    return { ...state, loadingNutritionLog: true};
  } else if (LOADING_ALL_NUTRITION_LOG_STATE) {
    return { ...state, loadingAllNutritionLog: true};
  } else {
    return state;
  }
}
